import VoMaterialTheme2 from "@vocollege/theme";

// Override some options on the default theme.
// @TODO Is there a better way to override?
// VoMaterialTheme2.palette.background.default = "#fafafa";
// VoMaterialTheme2.shape.borderRadius = 8;

export default VoMaterialTheme2;
